export default __webpack_public_path__ + "aebe172ddc4bb3a313778da9a7842c23.png";